/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: any; output: any; }
};

export type AddOnPolicyType =
  | 'CashBoost';

export type AddOnProductData = {
  __typename?: 'AddOnProductData';
  addOnPolicyNumber?: Maybe<Scalars['String']['output']>;
  addOnPolicyStatus?: Maybe<Scalars['String']['output']>;
  addOnPolicyType?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  phiPolicyNumber?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  countryName?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type AddressByType = {
  __typename?: 'AddressByType';
  postal?: Maybe<Address>;
  residential?: Maybe<Address>;
};

export type AddressByTypeInput = {
  postal?: InputMaybe<AddressInput>;
  residential?: InputMaybe<AddressInput>;
};

export type AddressInput = {
  countryName?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type AdhocPayment = {
  __typename?: 'AdhocPayment';
  paymentReferenceNumber?: Maybe<Scalars['String']['output']>;
  receiptNumber?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['String']['output']>;
  responseDescription?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Amount = {
  __typename?: 'Amount';
  fortnightly?: Maybe<Scalars['Float']['output']>;
  halfYearly?: Maybe<Scalars['Float']['output']>;
  monthly?: Maybe<Scalars['Float']['output']>;
  quarterly?: Maybe<Scalars['Float']['output']>;
  weekly?: Maybe<Scalars['Float']['output']>;
  yearly?: Maybe<Scalars['Float']['output']>;
};

export type ArchivedDocument = {
  __typename?: 'ArchivedDocument';
  archiveSource?: Maybe<Scalars['String']['output']>;
  communicationId?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  membershipId?: Maybe<Scalars['String']['output']>;
};

export type ArchivedDocumentInput = {
  archiveSource?: InputMaybe<Scalars['String']['input']>;
  communicationId?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  membershipId?: InputMaybe<Scalars['String']['input']>;
};

export type ArchivedDocumentUrl = {
  __typename?: 'ArchivedDocumentUrl';
  accessUrl?: Maybe<Scalars['String']['output']>;
};

export type AuthPayLoad = {
  __typename?: 'AuthPayLoad';
  access_token?: Maybe<Scalars['String']['output']>;
  expires_in?: Maybe<Scalars['Int']['output']>;
  membership?: Maybe<Membership>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  bsb: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
};

export type BankAccountInput = {
  bsb: Scalars['String']['input'];
  channel?: InputMaybe<ChannelType>;
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

export type BenefitEnquiryInput = {
  items: Array<InputMaybe<Item>>;
  memberId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type BenefitEnquiryResponse = {
  __typename?: 'BenefitEnquiryResponse';
  benefit?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<BenefitError>;
};

export type BenefitError = {
  __typename?: 'BenefitError';
  code?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
};

export type BhcCertificate = {
  __typename?: 'BhcCertificate';
  conditionCode?: Maybe<Scalars['String']['output']>;
  conditionCodeDescription?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  expiresWithin30Days?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeDescription?: Maybe<Scalars['String']['output']>;
};

export type BsbInformation = {
  __typename?: 'BsbInformation';
  bankCode: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  bsb: Scalars['String']['output'];
};

export type BsbInput = {
  bsb: Scalars['String']['input'];
};

export type Card = {
  __typename?: 'Card';
  cardNumber?: Maybe<Scalars['String']['output']>;
  dateLastIssued?: Maybe<Scalars['String']['output']>;
  issueNumber?: Maybe<Scalars['ID']['output']>;
};

export type CashBoostAddress = {
  __typename?: 'CashBoostAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  addressType: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
};

export type CashBoostBankingDetails = {
  __typename?: 'CashBoostBankingDetails';
  accountName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  bsb: Scalars['String']['output'];
  internalAccountId?: Maybe<Scalars['String']['output']>;
};

export type CashBoostBankingDetailsInput = {
  accountName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  bsb: Scalars['String']['input'];
  internalAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type CashBoostClaimDetails = {
  __typename?: 'CashBoostClaimDetails';
  latestClaimLodgementDate?: Maybe<Scalars['String']['output']>;
  latestClaimRefNumber?: Maybe<Scalars['String']['output']>;
  latestClaimStatus?: Maybe<Scalars['String']['output']>;
  lifetimeClaimCount?: Maybe<Scalars['Int']['output']>;
};

export type CashBoostClaimDetailsInput = {
  latestClaimLodgementDate?: InputMaybe<Scalars['String']['input']>;
  latestClaimRefNumber?: InputMaybe<Scalars['String']['input']>;
  latestClaimStatus?: InputMaybe<Scalars['String']['input']>;
  lifetimeClaimCount?: InputMaybe<Scalars['Int']['input']>;
};

export type CashBoostCommunicationDetails = {
  __typename?: 'CashBoostCommunicationDetails';
  address: CashBoostAddress;
  emailAddress: Scalars['String']['output'];
  phone?: Maybe<CashBoostPhone>;
};

export type CashBoostCreatePolicyInput = {
  coverType: Scalars['String']['input'];
  dataConsentIndicator: Scalars['Boolean']['input'];
  members: Array<CashBoostMemberInput>;
  paymentDetails: CashBoostPaymentDetailsInput;
  phiPolicyNumber: Scalars['Int']['input'];
  premiumDetails: CashBoostPremiumDetailsInput;
};

export type CashBoostMember = {
  __typename?: 'CashBoostMember';
  claimDetails?: Maybe<CashBoostClaimDetails>;
  coverStatus?: Maybe<Scalars['String']['output']>;
  dateOfBirth: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  insuredIndicator?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  memberType: Scalars['String']['output'];
  relationship?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  statusReason?: Maybe<Scalars['String']['output']>;
};

export type CashBoostMemberDetails = {
  __typename?: 'CashBoostMemberDetails';
  claimDetails?: Maybe<CashBoostClaimDetails>;
  dateOfBirth: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  insuredIndicator?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
};

export type CashBoostMemberInput = {
  claimDetails?: InputMaybe<CashBoostClaimDetailsInput>;
  dateOfBirth: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  insuredIndicator: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  memberType: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type CashBoostPaymentDetails = {
  __typename?: 'CashBoostPaymentDetails';
  arrearsAmount?: Maybe<Scalars['Float']['output']>;
  arrearsStartDate?: Maybe<Scalars['String']['output']>;
  bankingDetails?: Maybe<CashBoostBankingDetails>;
  nextPremiumPaymentDueDate?: Maybe<Scalars['String']['output']>;
  paymentFrequency: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
};

export type CashBoostPaymentDetailsInput = {
  arrearsAmount?: InputMaybe<Scalars['Float']['input']>;
  arrearsStartDate?: InputMaybe<Scalars['String']['input']>;
  bankingDetails?: InputMaybe<CashBoostBankingDetailsInput>;
  nextPremiumPaymentDueDate?: InputMaybe<Scalars['String']['input']>;
  paymentFrequency: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
};

export type CashBoostPhone = {
  __typename?: 'CashBoostPhone';
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneUseType: Scalars['String']['output'];
};

export type CashBoostPolicy = {
  __typename?: 'CashBoostPolicy';
  cancellationDate?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  coverType: Scalars['String']['output'];
  dataConsentIndicator: Scalars['Boolean']['output'];
  members: Array<CashBoostMember>;
  paymentDetails: CashBoostPaymentDetails;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  phiPolicyNumber: Scalars['String']['output'];
  policyLastUpdatedDate: Scalars['String']['output'];
  policyNumber: Scalars['String']['output'];
  policyOwner: CashBoostPolicyOwnerDetails;
  policyStartDate?: Maybe<Scalars['String']['output']>;
  policyStatus: Scalars['String']['output'];
  premiumDetails: CashBoostPremiumDetails;
  suspensionEndDate?: Maybe<Scalars['String']['output']>;
  suspensionStartDate?: Maybe<Scalars['String']['output']>;
};

export type CashBoostPolicyOwnerDetails = {
  __typename?: 'CashBoostPolicyOwnerDetails';
  communicationDetails: CashBoostCommunicationDetails;
  memberDetails: CashBoostMemberDetails;
};

export type CashBoostPolicySummary = {
  __typename?: 'CashBoostPolicySummary';
  phiPolicyNumber: Scalars['String']['output'];
  policyChangeDateTime: Scalars['String']['output'];
  policyNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CashBoostPremiumDetails = {
  __typename?: 'CashBoostPremiumDetails';
  chargeAmount?: Maybe<Scalars['Float']['output']>;
  nextPremiumPaymentDueAmount?: Maybe<Scalars['Float']['output']>;
  premiumAmount: Scalars['Float']['output'];
  previousPremiumAmount?: Maybe<Scalars['Float']['output']>;
  refundAmount?: Maybe<Scalars['Float']['output']>;
};

export type CashBoostPremiumDetailsInput = {
  premiumAmount: Scalars['Float']['input'];
  previousPremiumAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type CashBoostQuote = {
  __typename?: 'CashBoostQuote';
  coverType?: Maybe<Scalars['String']['output']>;
  members: Array<CashBoostQuoteMember>;
  overallEligibilityIndicator: Scalars['Boolean']['output'];
  overallIneligibilityReason?: Maybe<Scalars['String']['output']>;
  phiPolicyNumber: Scalars['String']['output'];
  premiumDetails?: Maybe<Array<CashBoostQuotePremiumDetails>>;
};

export type CashBoostQuoteMember = {
  __typename?: 'CashBoostQuoteMember';
  age: Scalars['Int']['output'];
  dateOfBirth: Scalars['String']['output'];
  eligibilityIndicator?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  ineligibilityReason?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  memberType: Scalars['String']['output'];
};

export type CashBoostQuotePremiumDetails = {
  __typename?: 'CashBoostQuotePremiumDetails';
  paymentFrequency: Scalars['String']['output'];
  premiumAmount: Scalars['Float']['output'];
};

export type CashBoostUpdateBankingDetailsInput = {
  bankingDetails: CashBoostBankingDetailsInput;
};

export type ChangeCover = {
  __typename?: 'ChangeCover';
  oneOffPayment?: Maybe<Scalars['Float']['output']>;
};

export type ChangeCoverInput = {
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeCoverResponse = {
  __typename?: 'ChangeCoverResponse';
  currentPrice?: Maybe<ProductPrice>;
  differenceToBePaid?: Maybe<Scalars['Float']['output']>;
  paysUntil?: Maybe<Scalars['String']['output']>;
  targetPrice?: Maybe<ProductPrice>;
};

export type ChangePasswordInput = {
  channel?: InputMaybe<ChannelType>;
  currentPassword: Scalars['String']['input'];
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
};

export type ChangeProductInput = {
  productId?: InputMaybe<Scalars['String']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChannelType =
  | 'email'
  | 'sms';

export type Charges = {
  __typename?: 'Charges';
  copayment?: Maybe<ChargesExcess>;
  excess?: Maybe<ChargesExcess>;
};

export type ChargesExcess = {
  __typename?: 'ChargesExcess';
  amount?: Maybe<Scalars['Float']['output']>;
  cappedAt?: Maybe<ExcessCappedAt>;
  waivers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Claim = {
  __typename?: 'Claim';
  ahmMedicalBenefitAmount?: Maybe<Scalars['Float']['output']>;
  benefitAmount: Scalars['Float']['output'];
  claimType?: Maybe<Scalars['String']['output']>;
  claimTypeLabel?: Maybe<Scalars['String']['output']>;
  dateReceived: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated This is not being returned from the resolver so is not requestable */
  items?: Maybe<Array<Maybe<ClaimDetailItems>>>;
  medicareBenefitAmount?: Maybe<Scalars['Float']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  paidAmount: Scalars['Float']['output'];
  paymentStatus: Scalars['String']['output'];
  providerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use supportingDocument. */
  referralLetter?: Maybe<Scalars['Upload']['output']>;
  requiresHif?: Maybe<Scalars['Boolean']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  supportingDocument?: Maybe<Scalars['Upload']['output']>;
  totalOutOfPocket: Scalars['Float']['output'];
  trial?: Maybe<Scalars['Boolean']['output']>;
};

export type ClaimDetailItems = {
  __typename?: 'ClaimDetailItems';
  ahmMedicalBenefitAmount?: Maybe<Scalars['Float']['output']>;
  benefitAmount: Scalars['Float']['output'];
  bodyPart?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  claimItemType?: Maybe<Scalars['String']['output']>;
  dateReceived: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  drugDescription?: Maybe<Scalars['String']['output']>;
  hifStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isInitialPaidAsSubsequent?: Maybe<Scalars['Boolean']['output']>;
  itemCode?: Maybe<Scalars['String']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  medicareBenefitAmount?: Maybe<Scalars['Float']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  mimsCode?: Maybe<Scalars['String']['output']>;
  paidAmount: Scalars['Float']['output'];
  paymentStatus: Scalars['String']['output'];
  /** Note: Provider address is not implemented in claims details as there hasn't been a use case yet */
  provider?: Maybe<Provider>;
  quantity?: Maybe<Scalars['Int']['output']>;
  servicesQty?: Maybe<Scalars['Int']['output']>;
  statusReason?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  totalOutOfPocket: Scalars['Float']['output'];
};

export type ClaimDetails = {
  __typename?: 'ClaimDetails';
  filteredByConsentStatus?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ClaimDetailItems>>>;
  summary?: Maybe<ClaimSummary>;
};

export type ClaimDetailsInput = {
  id: Scalars['ID']['input'];
};

export type ClaimHistoryAllInput = {
  claimItemTypes?: InputMaybe<Array<InputMaybe<ClaimItemType>>>;
  isRefetch?: InputMaybe<Scalars['Boolean']['input']>;
  memberId?: InputMaybe<Scalars['ID']['input']>;
  yearToBeFetched: Scalars['Int']['input'];
};

export type ClaimHistoryInput = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClaimItemType =
  | 'ancillary'
  | 'dental'
  | 'hospital'
  | 'medical';

export type ClaimItemsInput = {
  bodyPart?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  drugDescription?: InputMaybe<Scalars['String']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  mimsCode?: InputMaybe<Scalars['String']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ClaimSummary = {
  __typename?: 'ClaimSummary';
  ahmMedicalBenefitAmount?: Maybe<Scalars['Float']['output']>;
  benefitAmount?: Maybe<Scalars['Float']['output']>;
  claimType?: Maybe<Scalars['String']['output']>;
  claimTypeLabel?: Maybe<Scalars['String']['output']>;
  dateReceived?: Maybe<Scalars['String']['output']>;
  excessAmount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  medicareBenefitAmount?: Maybe<Scalars['Float']['output']>;
  paidAmount?: Maybe<Scalars['Float']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  totalOutOfPocket?: Maybe<Scalars['Float']['output']>;
};

export type ClaimType =
  | 'ambulance'
  | 'hospital'
  | 'medical';

export type ClaimTypeHelpText = {
  __typename?: 'ClaimTypeHelpText';
  hospital?: Maybe<Scalars['String']['output']>;
};

export type ClinicalCategories = {
  __typename?: 'ClinicalCategories';
  excluded?: Maybe<Array<Maybe<ClinicalCategory>>>;
  included?: Maybe<Array<Maybe<ClinicalCategory>>>;
  restricted?: Maybe<Array<Maybe<ClinicalCategory>>>;
};

export type ClinicalCategory = {
  __typename?: 'ClinicalCategory';
  description: Scalars['String']['output'];
  example?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportingCopy?: Maybe<Scalars['String']['output']>;
  waitingPeriod?: Maybe<WaitingPeriod>;
};

export type CommunicationPreferences = {
  __typename?: 'CommunicationPreferences';
  primaryContactByEmail?: Maybe<Scalars['Boolean']['output']>;
  receiveMarketing?: Maybe<ReceiveMarketing>;
};

export type ComposedProducts = {
  __typename?: 'ComposedProducts';
  extras?: Maybe<Scalars['String']['output']>;
  hospital?: Maybe<Scalars['String']['output']>;
};

export type CoverChange = {
  __typename?: 'CoverChange';
  productId?: Maybe<Scalars['String']['output']>;
  rebate?: Maybe<MembershipRebate>;
  scale?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type CoverChangesInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type CoverChangesResponse = {
  __typename?: 'CoverChangesResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  hasErrors?: Maybe<Scalars['Boolean']['output']>;
  payload?: Maybe<Array<Maybe<CoverChange>>>;
};

export type CreateClaimInput = {
  creditAccount?: InputMaybe<BankAccountInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<ClaimItemsInput>>>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  receipts?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  requiresHif?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  supportingDocument?: InputMaybe<Scalars['Upload']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateClaimResponse = {
  __typename?: 'CreateClaimResponse';
  benefitAmount?: Maybe<Scalars['Float']['output']>;
  claimType?: Maybe<Scalars['String']['output']>;
  claimTypeLabel?: Maybe<Scalars['String']['output']>;
  dateReceived?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<Maybe<ClaimDetailItems>>>;
  memberId?: Maybe<Scalars['String']['output']>;
  paidAmount?: Maybe<Scalars['Float']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use supportingDocument. */
  referralLetter?: Maybe<Scalars['Upload']['output']>;
  requiresHif?: Maybe<Scalars['Boolean']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  supportingDocument?: Maybe<Scalars['Upload']['output']>;
  totalOutOfPocket?: Maybe<Scalars['Float']['output']>;
  trial?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateMedicalHospitalClaimInput = {
  claimType: ClaimType;
  documents: Array<InputMaybe<Scalars['Upload']['input']>>;
};

export type CustomerNotifications = {
  __typename?: 'CustomerNotifications';
  checkDetails: Scalars['Boolean']['output'];
  multiplePolicies: Scalars['Boolean']['output'];
};

export type DirectDebitDetails = {
  __typename?: 'DirectDebitDetails';
  account?: Maybe<Scalars['String']['output']>;
  bsb?: Maybe<Scalars['String']['output']>;
  cardExpiry?: Maybe<Scalars['String']['output']>;
  /** masked card number as '•••• •••• •••• 4242' */
  cardNumber?: Maybe<Scalars['String']['output']>;
  /** visa, mastercard */
  cardType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DirectDebitDetailsInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bsb?: InputMaybe<Scalars['String']['input']>;
  cardExpiry?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  directDebitType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type Document = {
  __typename?: 'Document';
  archivedDocument?: Maybe<ArchivedDocument>;
  date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memberId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<DocumentTitle>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentTitle = {
  __typename?: 'DocumentTitle';
  full?: Maybe<Scalars['String']['output']>;
  redacted?: Maybe<Scalars['String']['output']>;
};

export type DrugSearchInput = {
  brandGeneric: Scalars['String']['input'];
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ExcessCappedAt = {
  __typename?: 'ExcessCappedAt';
  individual?: Maybe<Scalars['Float']['output']>;
  per?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['Float']['output']>;
};

export type ExtraService = {
  __typename?: 'ExtraService';
  annualLimit?: Maybe<ExtrasAnnualLimits>;
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  /** @deprecated Please use serviceId as id is automatically normalized and we don't want that for dynamic service limits. */
  id: Scalars['String']['output'];
  isNameCaseSensitive?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ExtraServiceItem>>>;
  limits?: Maybe<ExtrasLimitsConsumed>;
  name: Scalars['String']['output'];
  servedWaitingPeriod?: Maybe<ServedWaitingPeriod>;
  serviceId: Scalars['ID']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  /**
   * Waiting Periods at serviceGroup level are derived, not source of truth.
   * They are grouped at this level to make the information more digestible by users.
   * They are actually configured on the *item* level in WHICS and therefore can be different within one serviceGroup.
   */
  waitingPeriod?: Maybe<WaitingPeriod>;
};

export type ExtraServiceItem = {
  __typename?: 'ExtraServiceItem';
  code?: Maybe<Scalars['String']['output']>;
  /** items removed by government PHI reform; several natural therapy items */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Waiting period at the item level is used to calculate the overall status of the service. */
  servedWaitingPeriod?: Maybe<ServedWaitingPeriod>;
  unit?: Maybe<Scalars['String']['output']>;
  /** this is the value back. E.g. 70, $50 */
  value: Scalars['Float']['output'];
  valueFormat?: Maybe<Scalars['String']['output']>;
  /**
   * it can be shared between multiple services.
   * Items inside the same service can have different waiting period. See super extras Podiatry
   */
  waitingPeriod?: Maybe<WaitingPeriod>;
};

export type ExtrasAnnualLimits = {
  __typename?: 'ExtrasAnnualLimits';
  conditions?: Maybe<ExtrasLimitConditions>;
  family?: Maybe<Scalars['Float']['output']>;
  individual?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
};

export type ExtrasLimitConditions = {
  __typename?: 'ExtrasLimitConditions';
  every?: Maybe<Scalars['String']['output']>;
  lifetime?: Maybe<Scalars['Boolean']['output']>;
  per?: Maybe<Scalars['String']['output']>;
  restrictedInitialConsultation?: Maybe<Scalars['Boolean']['output']>;
};

export type ExtrasLimits = {
  __typename?: 'ExtrasLimits';
  amount?: Maybe<Scalars['Int']['output']>;
  applicableAfterYears?: Maybe<Scalars['Int']['output']>;
};

export type ExtrasLimitsConsumed = {
  __typename?: 'ExtrasLimitsConsumed';
  extrasLimitId: Scalars['ID']['output'];
  family?: Maybe<LimitItem>;
  individual?: Maybe<LimitItem>;
  isUnlimited?: Maybe<Scalars['Boolean']['output']>;
  lifetime?: Maybe<LimitItem>;
  limitMeter?: Maybe<LimitMeter>;
  memberId: Scalars['ID']['output'];
  servedWaitingPeriod?: Maybe<LimitWaitingPeriod>;
};

/** Extras product and all attributes, services, items, waiting period and limits. */
export type ExtrasServiceGroup = {
  __typename?: 'ExtrasServiceGroup';
  /** Flexi products share on single limit, for example, "essentials flexi basic plus". Limit ID and category from Whics is "single-limit-combined" */
  annualLimit?: Maybe<ExtrasAnnualLimits>;
  description?: Maybe<Scalars['String']['output']>;
  extrasLimitDisplayName: Scalars['String']['output'];
  extrasLimitId: Scalars['ID']['output'];
  isUnlimited?: Maybe<Scalars['Boolean']['output']>;
  limits?: Maybe<ExtrasLimitsConsumed>;
  services: Array<ExtraService>;
};

export type ExtrasServiceGroupResponse = {
  __typename?: 'ExtrasServiceGroupResponse';
  payload: Array<ExtrasServiceGroup>;
};

export type FindDoctorsResults = {
  __typename?: 'FindDoctorsResults';
  address?: Maybe<ProviderAddress>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  providerNumber: Scalars['ID']['output'];
};

export type FindHospitalsResults = {
  __typename?: 'FindHospitalsResults';
  address?: Maybe<ProviderAddress>;
  contractType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  providerNumber: Scalars['ID']['output'];
};

export type FindProviders = {
  __typename?: 'FindProviders';
  count: Scalars['Int']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<Maybe<FindProvidersResultTypes>>;
  searchType: SearchTypes;
};

export type FindProvidersInput = {
  filterNoGapDentists?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  providerNumber?: InputMaybe<Scalars['String']['input']>;
  searchType: SearchTypes;
  specialty?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FindProvidersResultTypes = FindDoctorsResults | FindHospitalsResults | FindProvidersResults;

export type FindProvidersResults = {
  __typename?: 'FindProvidersResults';
  address?: Maybe<ProviderAddress>;
  name: Scalars['String']['output'];
  noGapDental?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  providerNumber: Scalars['ID']['output'];
};

export type GenerateTaxStatementInput = {
  deliveryMode: Scalars['String']['input'];
  financialYear: Scalars['Int']['input'];
  memberIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type GetAppDemoModeCodeInput = {
  demoModeToken: Scalars['String']['input'];
  demoModeUser: Scalars['String']['input'];
};

export type GetOneOffPaymentInput = {
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type GetOneOffPaymentResponse = {
  __typename?: 'GetOneOffPaymentResponse';
  amount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated RET-3321 to be deleted once credit card surcharge has been completely removed from our frontends */
  amountIncludingCardSurcharge?: Maybe<Scalars['Float']['output']>;
  /** @deprecated RET-3321 to be deleted once credit card surcharge has been completely removed from our frontends */
  surchargeAmount?: Maybe<Scalars['Float']['output']>;
};

export type GuideUrl = {
  __typename?: 'GuideUrl';
  ambulance?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Scalars['String']['output']>;
  hospital?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['String']['output']>;
};

export type Hospital = {
  __typename?: 'Hospital';
  clinicalCategories?: Maybe<ClinicalCategories>;
};

export type HospitalCoverCheckAutomatedInput = {
  dateOfAdmission: Scalars['String']['input'];
  hospitalBeingAdmittedTo: Scalars['String']['input'];
  hospitalBeingAdmittedToLine1: Scalars['String']['input'];
  hospitalBeingAdmittedToPostCode: Scalars['String']['input'];
  hospitalBeingAdmittedToState: Scalars['String']['input'];
  hospitalBeingAdmittedToSuburb: Scalars['String']['input'];
  hospitalProviderNumber: Scalars['String']['input'];
  mbsItemCodes: Scalars['String']['input'];
  medicareCardColor: Scalars['String']['input'];
  memberBeingAdmitted: Scalars['String']['input'];
  nameOnMedicareCard: Scalars['String']['input'];
  nightsOfAdmission?: InputMaybe<Scalars['String']['input']>;
};

export type HospitalCoverCheckAutomatedResponse = {
  __typename?: 'HospitalCoverCheckAutomatedResponse';
  excessDescription?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
};

export type HospitalSearchInput = {
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Hoyts = {
  __typename?: 'Hoyts';
  url: Scalars['String']['output'];
};

export type IsEmailAvailableInput = {
  email: Scalars['String']['input'];
};

export type Item = {
  code: Scalars['String']['input'];
  cost: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
};

export type Lead = {
  __typename?: 'Lead';
  id: Scalars['ID']['output'];
};

export type LimitItem = {
  __typename?: 'LimitItem';
  futureLimit?: Maybe<Scalars['Float']['output']>;
  futureRollover?: Maybe<Scalars['Float']['output']>;
  limit?: Maybe<Scalars['Float']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  remaining?: Maybe<Scalars['Float']['output']>;
  rollover?: Maybe<Scalars['Float']['output']>;
  spent?: Maybe<Scalars['Float']['output']>;
  totalLimit?: Maybe<Scalars['Float']['output']>;
  used?: Maybe<Scalars['Float']['output']>;
};

export type LimitMeter = {
  __typename?: 'LimitMeter';
  /** This field indicates if the extras service group is currently claimable. */
  claimable?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Float']['output']>;
  remaining?: Maybe<Scalars['Float']['output']>;
  rollover?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LimitWaitingPeriod = {
  __typename?: 'LimitWaitingPeriod';
  endDate?: Maybe<Scalars['String']['output']>;
  lineDescription?: Maybe<Scalars['String']['output']>;
  serviceNamesByWaitingPeriod?: Maybe<Array<ServiceNamesByWaitingPeriod>>;
  sharedLimitDisplayNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type LimitsInput = {
  joinDate: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
};

export type LimitsRollover = {
  __typename?: 'LimitsRollover';
  isApplicable?: Maybe<Scalars['Boolean']['output']>;
  isEligibleForFamily?: Maybe<Scalars['Boolean']['output']>;
};

export type LivePersonAuthInput = {
  mfaToken?: InputMaybe<Scalars['String']['input']>;
};

export type LivePersonPayLoad = {
  __typename?: 'LivePersonPayLoad';
  expiresIn: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type LivechatAuthPayLoad = {
  __typename?: 'LivechatAuthPayLoad';
  membershipId: Scalars['String']['output'];
  securityCode: Scalars['String']['output'];
};

export type MaxEqualConsecutiveCharacters = {
  __typename?: 'MaxEqualConsecutiveCharacters';
  enable: Scalars['Boolean']['output'];
  numberCharacters?: Maybe<Scalars['Int']['output']>;
};

export type Medicare = {
  __typename?: 'Medicare';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type MedicareCard = {
  __typename?: 'MedicareCard';
  expiry?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type Member = {
  __typename?: 'Member';
  /** Optical certificates are filtered out as well as certificates for members who have not provided consent */
  bhcCertificates?: Maybe<Array<Maybe<BhcCertificate>>>;
  card?: Maybe<Card>;
  certifiedAge?: Maybe<Scalars['Int']['output']>;
  /** consentStatus is for extras claims consent */
  consentStatus?: Maybe<Scalars['String']['output']>;
  continuous?: Maybe<Scalars['Boolean']['output']>;
  dateOfBirth: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enrolCode?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  /** hasGivenPersonalInformationAndClaimsConsent can be used as consent for looking up a members hospital claims */
  hasGivenPersonalInformationAndClaimsConsent?: Maybe<Scalars['Boolean']['output']>;
  hasObtainedTransferCertificate?: Maybe<Scalars['Boolean']['output']>;
  joinDate?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  medicare?: Maybe<MedicareCard>;
  memberId: Scalars['ID']['output'];
  memberStatus: Scalars['String']['output'];
  /** PatientId is displayed on digital card page for claiming purposes */
  patientId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Phone>;
  relationship: Scalars['String']['output'];
  spousalAuthority?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MemberEmailPhoneInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
};

export type MembersPriceInput = {
  certifiedAge?: InputMaybe<Scalars['Int']['input']>;
  continuous?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type Membership = {
  __typename?: 'Membership';
  address?: Maybe<AddressByType>;
  ambulanceSurchargeExempted?: Maybe<Scalars['Boolean']['output']>;
  campaignCode?: Maybe<Scalars['String']['output']>;
  communicationPreferences?: Maybe<CommunicationPreferences>;
  coverCampaignCode?: Maybe<Scalars['String']['output']>;
  creditAccount?: Maybe<BankAccount>;
  customerNotifications?: Maybe<CustomerNotifications>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fund?: Maybe<Scalars['String']['output']>;
  /** @deprecated RET-3321 to be deleted once credit card surcharge has been completely removed from our frontends */
  hasSurcharge?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isUsingOldProductCode?: Maybe<Scalars['Boolean']['output']>;
  joinDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lhc?: Maybe<Scalars['Float']['output']>;
  limitsRollover?: Maybe<LimitsRollover>;
  medicare?: Maybe<Medicare>;
  members?: Maybe<Array<Maybe<Member>>>;
  onboarding?: Maybe<Onboarding>;
  onboardingChecklist?: Maybe<OnboardingChecklist>;
  paidToDate?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<PaymentDetails>;
  payments?: Maybe<Payments>;
  phone?: Maybe<Phone>;
  policy?: Maybe<MembershipPolicy>;
  product?: Maybe<Product>;
  rateCode?: Maybe<Scalars['String']['output']>;
  rebate?: Maybe<MembershipRebate>;
  referralCode?: Maybe<Scalars['String']['output']>;
  returnMail?: Maybe<Scalars['Boolean']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  spouseAuthority?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  suspendedDetails?: Maybe<SuspendedDetails>;
  youthDiscount?: Maybe<YouthDiscount>;
};

export type MembershipPolicy = {
  __typename?: 'MembershipPolicy';
  changedDates: ServiceDates;
  resetDates: ServiceDates;
  state: Scalars['String']['output'];
};

export type MembershipRebate = {
  __typename?: 'MembershipRebate';
  incomeTier?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isApplied?: Maybe<Scalars['Boolean']['output']>;
  isPending?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  savingsProvisionsAgeBracket?: Maybe<Scalars['String']['output']>;
};

export type Meta = {
  __typename?: 'Meta';
  dateReset?: Maybe<Scalars['String']['output']>;
  futureBenefit?: Maybe<Scalars['Float']['output']>;
  waitingPeriodEndDate?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelCashBoostPolicy: CashBoostPolicy;
  changePassword?: Maybe<Scalars['String']['output']>;
  changeProduct?: Maybe<Scalars['Boolean']['output']>;
  createCashBoostPolicy: CashBoostPolicy;
  createClaim?: Maybe<CreateClaimResponse>;
  createLead?: Maybe<Lead>;
  createMedicalHospitalClaim: Scalars['String']['output'];
  generateTaxStatement?: Maybe<Scalars['String']['output']>;
  getAppDemoModeCode: Scalars['String']['output'];
  hospitalCoverCheckAutomated?: Maybe<HospitalCoverCheckAutomatedResponse>;
  livePersonAuth: LivePersonPayLoad;
  livechatAuth: LivechatAuthPayLoad;
  loginUser: AuthPayLoad;
  logoutUser?: Maybe<Scalars['String']['output']>;
  npsRequestACallFeedback: Scalars['Boolean']['output'];
  pauseCover?: Maybe<Scalars['String']['output']>;
  registerUser: RegisterPayLoad;
  reissueCard?: Maybe<ReissueCardResponse>;
  saveOnboardingChecklist?: Maybe<OnboardingChecklist>;
  sendMfa?: Maybe<Scalars['String']['output']>;
  setOnboardingDismissed?: Maybe<Scalars['String']['output']>;
  submitAdhocPayment: AdhocPayment;
  updateAgr?: Maybe<Membership>;
  updateCashBoostBankDetails: CashBoostPolicy;
  updateCashBoostCreditCardDetails: CashBoostPolicy;
  updateCommunicationPreferences?: Maybe<CommunicationPreferences>;
  updateCreditAccount?: Maybe<Membership>;
  updateDirectDebitDetails?: Maybe<NewDirectDebitDetails>;
  updateIncomeTier?: Maybe<Membership>;
  updateMember?: Maybe<Member>;
  updateMembers?: Maybe<Array<Maybe<Member>>>;
  updatePaymentFrequency?: Maybe<NewDirectDebitDetails>;
  updatePrimaryMember?: Maybe<Membership>;
  uploadDocuments?: Maybe<Scalars['String']['output']>;
  verifyMfa?: Maybe<Scalars['String']['output']>;
};


export type MutationChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordInput>;
};


export type MutationChangeProductArgs = {
  input?: InputMaybe<ChangeProductInput>;
};


export type MutationCreateCashBoostPolicyArgs = {
  input: CashBoostCreatePolicyInput;
};


export type MutationCreateClaimArgs = {
  input?: InputMaybe<CreateClaimInput>;
};


export type MutationCreateLeadArgs = {
  input?: InputMaybe<CreateLeadInput>;
};


export type MutationCreateMedicalHospitalClaimArgs = {
  input?: InputMaybe<CreateMedicalHospitalClaimInput>;
};


export type MutationGenerateTaxStatementArgs = {
  input: GenerateTaxStatementInput;
};


export type MutationGetAppDemoModeCodeArgs = {
  input?: InputMaybe<GetAppDemoModeCodeInput>;
};


export type MutationHospitalCoverCheckAutomatedArgs = {
  input?: InputMaybe<HospitalCoverCheckAutomatedInput>;
};


export type MutationLivePersonAuthArgs = {
  input?: InputMaybe<LivePersonAuthInput>;
};


export type MutationLoginUserArgs = {
  input?: InputMaybe<UserLoginInput>;
};


export type MutationNpsRequestACallFeedbackArgs = {
  input?: InputMaybe<NpsRequestACallFeedbackInput>;
};


export type MutationPauseCoverArgs = {
  input?: InputMaybe<PauseCoverInput>;
};


export type MutationRegisterUserArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationReissueCardArgs = {
  input?: InputMaybe<ReissueCardInput>;
};


export type MutationSaveOnboardingChecklistArgs = {
  input?: InputMaybe<SaveOnboardingChecklistInput>;
};


export type MutationSendMfaArgs = {
  input?: InputMaybe<SendMfaInput>;
};


export type MutationSubmitAdhocPaymentArgs = {
  input: SubmitAdhocPaymentInput;
};


export type MutationUpdateAgrArgs = {
  input?: InputMaybe<UpdateAgrInput>;
};


export type MutationUpdateCashBoostBankDetailsArgs = {
  input: CashBoostUpdateBankingDetailsInput;
};


export type MutationUpdateCommunicationPreferencesArgs = {
  input?: InputMaybe<UpdateCommunicationPreferencesInput>;
};


export type MutationUpdateCreditAccountArgs = {
  input?: InputMaybe<UpdateCreditAccountInput>;
};


export type MutationUpdateDirectDebitDetailsArgs = {
  input?: InputMaybe<DirectDebitDetailsInput>;
};


export type MutationUpdateIncomeTierArgs = {
  input?: InputMaybe<UpdateIncomeTierInput>;
};


export type MutationUpdateMemberArgs = {
  input?: InputMaybe<UpdateMemberInput>;
};


export type MutationUpdateMembersArgs = {
  input?: InputMaybe<UpdateMembersInput>;
};


export type MutationUpdatePaymentFrequencyArgs = {
  input?: InputMaybe<UpdatePaymentFrequencyInput>;
};


export type MutationUpdatePrimaryMemberArgs = {
  input?: InputMaybe<UpdatePrimaryMemberInput>;
};


export type MutationUploadDocumentsArgs = {
  input: UploadDocumentsInput;
};


export type MutationVerifyMfaArgs = {
  input?: InputMaybe<VerifyMfaInput>;
};

export type NewDirectDebitDetails = {
  __typename?: 'NewDirectDebitDetails';
  /** @deprecated RET-3321 to be deleted once credit card surcharge has been completely removed from our frontends */
  hasSurcharge?: Maybe<Scalars['Boolean']['output']>;
  nextDeduction?: Maybe<Scalars['Float']['output']>;
  /** @deprecated RET-3321 to be deleted once credit card surcharge has been completely removed from our frontends */
  nextDeductionWithSurcharge?: Maybe<Scalars['Float']['output']>;
  regularAmount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated RET-3321 to be deleted once credit card surcharge has been completely removed from our frontends */
  regularAmountWithSurcharge?: Maybe<Scalars['Float']['output']>;
};

export type NpsRequestACallFeedbackInput = {
  callbackTime: Scalars['String']['input'];
  isMember: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  tellUsMore: Scalars['String']['input'];
};

export type Onboarding = {
  __typename?: 'Onboarding';
  isApplicable?: Maybe<Scalars['Boolean']['output']>;
  isDismissed?: Maybe<Scalars['Boolean']['output']>;
};

export type OnboardingChecklist = {
  __typename?: 'OnboardingChecklist';
  isApplicable?: Maybe<Scalars['Boolean']['output']>;
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  isDismissed?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<OnboardingChecklistItem>>>;
  percentageCompleted?: Maybe<Scalars['String']['output']>;
};

export type OnboardingChecklistItem = {
  __typename?: 'OnboardingChecklistItem';
  description?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  timeLength?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type OnboardingChecklistItemInput = {
  id: Scalars['String']['input'];
  isCompleted: Scalars['Boolean']['input'];
};

export type OnboardingInput = {
  joinDate: Scalars['String']['input'];
  productType?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordConfig = {
  __typename?: 'PasswordConfig';
  lowerCase: Scalars['Boolean']['output'];
  maxEqualConsecutiveCharacters: MaxEqualConsecutiveCharacters;
  maxLength: Scalars['Int']['output'];
  minLength?: Maybe<Scalars['Int']['output']>;
  numbers: Scalars['Boolean']['output'];
  specialCharacters: Scalars['Boolean']['output'];
  upperCase: Scalars['Boolean']['output'];
};

export type PauseCoverInput = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  supportingDocuments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
};

export type PauseCoverPeriod = {
  __typename?: 'PauseCoverPeriod';
  dateFrom?: Maybe<Scalars['String']['output']>;
  dateSubmitted?: Maybe<Scalars['String']['output']>;
  dateTo?: Maybe<Scalars['String']['output']>;
};

export type PaymentDatePaidTo = {
  __typename?: 'PaymentDatePaidTo';
  next?: Maybe<PaymentsNext>;
};

export type PaymentDatePaidToInput = {
  date?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  bsb?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type PaymentHistory = {
  __typename?: 'PaymentHistory';
  list?: Maybe<Array<Maybe<PaymentHistoryItem>>>;
  nextPagePointer?: Maybe<Scalars['String']['output']>;
  pageSize?: Maybe<Scalars['String']['output']>;
};

export type PaymentHistoryInput = {
  nextPagePointer?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentHistoryItem = {
  __typename?: 'PaymentHistoryItem';
  amount: Scalars['Float']['output'];
  dateReceipt: Scalars['String']['output'];
  hasReceipt?: Maybe<Scalars['Boolean']['output']>;
  reference: Scalars['ID']['output'];
  requestedFromPagePointer?: Maybe<Scalars['String']['output']>;
  transferType: Scalars['String']['output'];
};

export type PaymentStatement = {
  __typename?: 'PaymentStatement';
  paymentStatement?: Maybe<Scalars['String']['output']>;
};

export type PaymentStatementInput = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  directDebitPaymentHistory?: Maybe<DirectDebitDetails>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonDescription?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type Payments = {
  __typename?: 'Payments';
  arrears?: Maybe<Scalars['Float']['output']>;
  directDebitDetails?: Maybe<DirectDebitDetails>;
  directDebitType?: Maybe<Scalars['String']['output']>;
  frequency: Scalars['String']['output'];
  next?: Maybe<PaymentsNext>;
  paymentStatus?: Maybe<PaymentStatus>;
  regular: PaymentsRegular;
};

export type PaymentsNext = {
  __typename?: 'PaymentsNext';
  date?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** @deprecated RET-3321 to be deleted once credit card surcharge has been completely removed from our frontends */
  surcharge?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PaymentsRegular = {
  __typename?: 'PaymentsRegular';
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** @deprecated RET-3321 to be deleted once credit card surcharge has been completely removed from our frontends */
  surcharge?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PendingClaim = {
  __typename?: 'PendingClaim';
  dateReceived?: Maybe<Scalars['String']['output']>;
};

export type PharmacyItem = {
  __typename?: 'PharmacyItem';
  benefitRule?: Maybe<Scalars['String']['output']>;
  drugDescription?: Maybe<Scalars['String']['output']>;
  itemCode?: Maybe<Scalars['String']['output']>;
  mimsCode?: Maybe<Scalars['String']['output']>;
  packNumber?: Maybe<Scalars['Int']['output']>;
  packSize?: Maybe<Scalars['Int']['output']>;
};

export type PharmacyItems = {
  __typename?: 'PharmacyItems';
  items?: Maybe<Array<Maybe<PharmacyItem>>>;
  strength?: Maybe<Scalars['String']['output']>;
};

export type PharmacyItemsSearch = {
  __typename?: 'PharmacyItemsSearch';
  brandName?: Maybe<Scalars['String']['output']>;
  drugType?: Maybe<Scalars['String']['output']>;
  genericName?: Maybe<Scalars['String']['output']>;
  strengths?: Maybe<Array<Maybe<PharmacyItems>>>;
};

export type Phone = {
  __typename?: 'Phone';
  home?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  work?: Maybe<Scalars['String']['output']>;
};

export type PhoneEmailDuplication = {
  __typename?: 'PhoneEmailDuplication';
  emailDuplication?: Maybe<Scalars['Boolean']['output']>;
  phoneDuplication?: Maybe<Scalars['Boolean']['output']>;
};

export type PhoneInput = {
  home?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<Scalars['String']['input']>;
};

export type PriceParams = {
  ageBracket?: InputMaybe<Scalars['String']['input']>;
  ambulanceSurchargeExempted?: InputMaybe<Scalars['Boolean']['input']>;
  clientYouthDiscountAge?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  fund?: InputMaybe<Scalars['String']['input']>;
  incomeTier?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<InputMaybe<MembersPriceInput>>>;
  rateCode?: InputMaybe<Scalars['String']['input']>;
  rebate?: InputMaybe<Scalars['Boolean']['input']>;
  reload?: InputMaybe<Scalars['Boolean']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  spouseYouthDiscountAge?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type Product = {
  __typename?: 'Product';
  charges?: Maybe<Charges>;
  claimTypeHelpText?: Maybe<ClaimTypeHelpText>;
  composedProducts?: Maybe<ComposedProducts>;
  content?: Maybe<ProductContent>;
  extras?: Maybe<Array<Maybe<ExtrasServiceGroup>>>;
  extrasLimits?: Maybe<Array<Maybe<ExtrasLimits>>>;
  extrasType?: Maybe<Scalars['String']['output']>;
  features?: Maybe<ProductFeatures>;
  guideUrl?: Maybe<GuideUrl>;
  hospital?: Maybe<Hospital>;
  hospitalTier?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFixedBenefitProduct?: Maybe<Scalars['Boolean']['output']>;
  loyalty?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  name: Scalars['String']['output'];
  nameExtras?: Maybe<Scalars['String']['output']>;
  nameHospital?: Maybe<Scalars['String']['output']>;
  /** This is the parent product related to the hospital component */
  parentProductId?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<ProductPrice>;
  rank?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Rating>;
  relatedProducts?: Maybe<RelatedProducts>;
  scales?: Maybe<Scales>;
  shortName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProductContent = {
  __typename?: 'ProductContent';
  benefits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  highlights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  longForm?: Maybe<Scalars['String']['output']>;
  tierDescription?: Maybe<Scalars['String']['output']>;
};

export type ProductFeatures = {
  __typename?: 'ProductFeatures';
  noGapDental?: Maybe<Scalars['Boolean']['output']>;
  noGapDentalLimited?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  amount?: Maybe<Amount>;
  fortnightly?: Maybe<Scalars['Float']['output']>;
  halfYearly?: Maybe<Scalars['Float']['output']>;
  lhc?: Maybe<Scalars['Float']['output']>;
  monthly?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  quarterly?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  weekly?: Maybe<Scalars['Float']['output']>;
  yearly?: Maybe<Scalars['Float']['output']>;
  youthDiscount?: Maybe<Scalars['Float']['output']>;
};

export type ProductRecommendationEngineServices = {
  __typename?: 'ProductRecommendationEngineServices';
  ageRange: Scalars['String']['output'];
  recommendedServices: Array<Maybe<Scalars['String']['output']>>;
  scale: Scalars['String']['output'];
  serviceType: ProductType;
  services: Array<Maybe<Scalars['String']['output']>>;
};

export type ProductRecommendationEngineServicesInput = {
  serviceType: ProductType;
};

export type ProductType =
  | 'extras'
  | 'hospital';

export type ProductWithServiceInput = {
  productType: ProductType;
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ProductsWithPricesByMembershipScaleInput = {
  priceParams?: InputMaybe<PriceParams>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ProductsWithPricesInput = {
  priceParams?: InputMaybe<PriceParams>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Provider = {
  __typename?: 'Provider';
  address?: Maybe<ProviderAddress>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ProviderAddress = {
  __typename?: 'ProviderAddress';
  country?: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
};

export type ProviderSearchInput = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  isFilteringExcludedProviders?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  q: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  bsbInformation?: Maybe<BsbInformation>;
  cashBoostPolicy: CashBoostPolicy;
  cashBoostPolicySummaries: CashBoostPolicySummary;
  cashBoostQuote: CashBoostQuote;
  checkWaitingPeriodForItem?: Maybe<WaitingPeriodForItem>;
  claimDetails?: Maybe<ClaimDetails>;
  /**
   * It returns all members if no memberId is supplied
   * It returns the last 3 years if no fromDate and toDate are supplied
   */
  claimHistory?: Maybe<Array<Maybe<Claim>>>;
  claimHistoryAll?: Maybe<ClaimHistoryAllResults>;
  coverChanges?: Maybe<CoverChangesResponse>;
  extrasServiceGroupsBreakdownWithPayload?: Maybe<ExtrasServiceGroupResponse>;
  findProviders?: Maybe<FindProviders>;
  generatePaymentStatement?: Maybe<PaymentStatement>;
  generateReceipt?: Maybe<Receipt>;
  getAddOnProduct?: Maybe<AddOnProductData>;
  getArchivedDocumentUrl?: Maybe<ArchivedDocumentUrl>;
  getChangeCoverPrices?: Maybe<ChangeCoverResponse>;
  getDocuments?: Maybe<Array<Maybe<Document>>>;
  getHoytsUrl: Hoyts;
  getOnboarding?: Maybe<Onboarding>;
  getOnboardingChecklistItems?: Maybe<OnboardingChecklist>;
  getOneOffPayment?: Maybe<GetOneOffPaymentResponse>;
  getPasswordPolicy?: Maybe<PasswordConfig>;
  getServices?: Maybe<Array<Maybe<Service>>>;
  hello: Scalars['String']['output'];
  hospitalSearch?: Maybe<Array<Maybe<FindHospitalsResults>>>;
  isEmailAvailable?: Maybe<Scalars['Boolean']['output']>;
  members?: Maybe<Array<Maybe<Member>>>;
  membership?: Maybe<Membership>;
  pauseCoverRequest?: Maybe<PauseCoverPeriod>;
  paymentDatePaidTo?: Maybe<PaymentDatePaidTo>;
  /** @deprecated Please use paymentHistoryWithPagination operation */
  paymentHistory?: Maybe<Array<Maybe<PaymentHistoryItem>>>;
  paymentHistoryWithPagination?: Maybe<PaymentHistory>;
  pendingClaims?: Maybe<Array<Maybe<PendingClaim>>>;
  performBenefitEnquiry?: Maybe<Array<Maybe<BenefitEnquiryResponse>>>;
  pharmacyItemsSearch?: Maybe<Array<Maybe<PharmacyItemsSearch>>>;
  product?: Maybe<Product>;
  productRecommendationEngineServices: ProductRecommendationEngineServices;
  productsWithPrices?: Maybe<Array<Maybe<Product>>>;
  productsWithPricesByMembershipScale?: Maybe<Array<Maybe<Product>>>;
  productsWithServices?: Maybe<Array<Scalars['ID']['output']>>;
  /** It searches for providers using AWS provider backend. */
  providerSearch?: Maybe<Array<Maybe<Provider>>>;
  recommendProducts: RecommendProducts;
  recommendedProductFromSpark?: Maybe<RecommendedProductFromSpark>;
  referralHistory?: Maybe<Array<Maybe<ReferralHistoryItem>>>;
  resolveProductId?: Maybe<Scalars['String']['output']>;
  servedWaitingPeriods?: Maybe<Array<Maybe<ServedWaitingPeriod>>>;
  validatePhoneAndEmailDuplication?: Maybe<PhoneEmailDuplication>;
  validateReferralCode?: Maybe<ValidatedReferralCode>;
};


export type QueryBsbInformationArgs = {
  input?: InputMaybe<BsbInput>;
};


export type QueryCheckWaitingPeriodForItemArgs = {
  input: WaitingPeriodForItemInput;
};


export type QueryClaimDetailsArgs = {
  input?: InputMaybe<ClaimDetailsInput>;
};


export type QueryClaimHistoryArgs = {
  input?: InputMaybe<ClaimHistoryInput>;
};


export type QueryClaimHistoryAllArgs = {
  input?: InputMaybe<ClaimHistoryAllInput>;
};


export type QueryCoverChangesArgs = {
  input?: InputMaybe<CoverChangesInput>;
};


export type QueryExtrasServiceGroupsBreakdownWithPayloadArgs = {
  fetchWaitingPeriods?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<LimitsInput>;
};


export type QueryFindProvidersArgs = {
  input?: InputMaybe<FindProvidersInput>;
};


export type QueryGeneratePaymentStatementArgs = {
  input?: InputMaybe<PaymentStatementInput>;
};


export type QueryGenerateReceiptArgs = {
  input?: InputMaybe<ReceiptInput>;
};


export type QueryGetAddOnProductArgs = {
  addOnPolicyType: AddOnPolicyType;
};


export type QueryGetArchivedDocumentUrlArgs = {
  input?: InputMaybe<ArchivedDocumentInput>;
};


export type QueryGetChangeCoverPricesArgs = {
  input?: InputMaybe<ChangeCoverInput>;
};


export type QueryGetOnboardingArgs = {
  input: OnboardingInput;
};


export type QueryGetOneOffPaymentArgs = {
  input?: InputMaybe<GetOneOffPaymentInput>;
};


export type QueryGetServicesArgs = {
  input?: InputMaybe<ServiceInput>;
};


export type QueryHospitalSearchArgs = {
  input?: InputMaybe<HospitalSearchInput>;
};


export type QueryIsEmailAvailableArgs = {
  input?: InputMaybe<IsEmailAvailableInput>;
};


export type QueryPaymentDatePaidToArgs = {
  input?: InputMaybe<PaymentDatePaidToInput>;
};


export type QueryPaymentHistoryWithPaginationArgs = {
  input?: InputMaybe<PaymentHistoryInput>;
};


export type QueryPerformBenefitEnquiryArgs = {
  input?: InputMaybe<BenefitEnquiryInput>;
};


export type QueryPharmacyItemsSearchArgs = {
  input?: InputMaybe<DrugSearchInput>;
};


export type QueryProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryProductRecommendationEngineServicesArgs = {
  input?: InputMaybe<ProductRecommendationEngineServicesInput>;
};


export type QueryProductsWithPricesArgs = {
  input?: InputMaybe<ProductsWithPricesInput>;
};


export type QueryProductsWithPricesByMembershipScaleArgs = {
  input?: InputMaybe<ProductsWithPricesByMembershipScaleInput>;
};


export type QueryProductsWithServicesArgs = {
  input?: InputMaybe<ProductWithServiceInput>;
};


export type QueryProviderSearchArgs = {
  input?: InputMaybe<ProviderSearchInput>;
};


export type QueryRecommendProductsArgs = {
  input?: InputMaybe<RecommendProductsInput>;
};


export type QueryRecommendedProductFromSparkArgs = {
  input?: InputMaybe<RecommendedProductFromSparkInput>;
};


export type QueryResolveProductIdArgs = {
  internalProductId: Scalars['ID']['input'];
};


export type QueryServedWaitingPeriodsArgs = {
  input: ServedWaitingPeriodInput;
};


export type QueryValidatePhoneAndEmailDuplicationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  primaryMemberId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateReferralCodeArgs = {
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type Rating = {
  __typename?: 'Rating';
  extras?: Maybe<Scalars['Int']['output']>;
  hospital?: Maybe<Scalars['Int']['output']>;
};

export type Receipt = {
  __typename?: 'Receipt';
  receipt?: Maybe<Scalars['String']['output']>;
};

export type ReceiptInput = {
  reference?: InputMaybe<Scalars['String']['input']>;
  requestedFromPagePointer?: InputMaybe<Scalars['String']['input']>;
};

export type ReceiveMarketing = {
  __typename?: 'ReceiveMarketing';
  email?: Maybe<Scalars['Boolean']['output']>;
  sms?: Maybe<Scalars['Boolean']['output']>;
};

export type ReceiveMarketingInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecommendProducts = {
  __typename?: 'RecommendProducts';
  extras?: Maybe<Scalars['ID']['output']>;
  hospital?: Maybe<Scalars['ID']['output']>;
};

export type RecommendProductsInput = {
  /** Date of birth in standard format DD/MM/YYYY */
  dob: Scalars['String']['input'];
  scale: Scalars['String']['input'];
};

export type RecommendedCoverOptions = {
  __typename?: 'RecommendedCoverOptions';
  extras?: Maybe<Product>;
  hospital?: Maybe<Product>;
};

export type RecommendedProductFromSpark = {
  __typename?: 'RecommendedProductFromSpark';
  bestCover?: Maybe<RecommendedCoverOptions>;
  minimumCover?: Maybe<RecommendedCoverOptions>;
  noExtrasClaimsFoundInSparkBackend?: Maybe<Scalars['Boolean']['output']>;
};

export type RecommendedProductFromSparkInput = {
  priceParams?: InputMaybe<PriceParams>;
  requestedProductType: RequestableRecommendedProductType;
  requiredServices?: InputMaybe<RequiredServices>;
  useClaimsInformationIndicator?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReferralHistoryItem = {
  __typename?: 'ReferralHistoryItem';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  dateNominated?: Maybe<Scalars['String']['output']>;
  datePaid?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RegisterPayLoad = {
  __typename?: 'RegisterPayLoad';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ReissueCardInput = {
  memberId: Scalars['String']['input'];
};

export type ReissueCardResponse = {
  __typename?: 'ReissueCardResponse';
  memberId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** This is actually an instance of type Product but better expose only what we need for now. */
export type RelatedProduct = {
  __typename?: 'RelatedProduct';
  id: Scalars['ID']['output'];
};

export type RelatedProducts = {
  __typename?: 'RelatedProducts';
  extras?: Maybe<RelatedProduct>;
  hospital?: Maybe<RelatedProduct>;
};

export type RequestableRecommendedProductType =
  | 'combined'
  | 'extras'
  | 'hospital';

export type RequiredServices = {
  extras?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hospital?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/**
 * It returns the cover checklist items just like inside the membership.
 * so clients can update their local cache without refetching the membership.
 */
export type SaveOnboardingChecklistInput = {
  /** When the whole checklist is dismissed. Required when 'item' is not provided. */
  isDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** When a single checklist item is updated. Required when 'isDismissed' is not provided or false. */
  item?: InputMaybe<OnboardingChecklistItemInput>;
};

export type Scales = {
  __typename?: 'Scales';
  selectable?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  supported?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SearchTypes =
  | 'doctor'
  | 'hospital'
  | 'provider';

export type SendMfaInput = {
  channel?: InputMaybe<ChannelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
};

export type ServedWaitingPeriod = {
  __typename?: 'ServedWaitingPeriod';
  benefit?: Maybe<Scalars['Float']['output']>;
  dateReset?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  extrasLimitId?: Maybe<Scalars['String']['output']>;
  futureIndividualLimit?: Maybe<Scalars['Float']['output']>;
  futureIndividualLimitRemaining?: Maybe<Scalars['Float']['output']>;
  futureIndividualRollover?: Maybe<Scalars['Float']['output']>;
  futurePolicyLimit?: Maybe<Scalars['Float']['output']>;
  futurePolicyLimitRemaining?: Maybe<Scalars['Float']['output']>;
  futurePolicyRollover?: Maybe<Scalars['Float']['output']>;
  individualLimit?: Maybe<Scalars['Float']['output']>;
  individualLimitPlusRollover?: Maybe<Scalars['Float']['output']>;
  individualLimitRemaining?: Maybe<Scalars['Float']['output']>;
  individualLimitUsed?: Maybe<Scalars['Float']['output']>;
  individualRollover?: Maybe<Scalars['Float']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<ExtraServiceItem>>>;
  level?: Maybe<Scalars['String']['output']>;
  lineDescription?: Maybe<Scalars['String']['output']>;
  policyLimit?: Maybe<Scalars['Float']['output']>;
  policyLimitPlusRollover?: Maybe<Scalars['Float']['output']>;
  policyLimitRemaining?: Maybe<Scalars['Float']['output']>;
  policyLimitUsed?: Maybe<Scalars['Float']['output']>;
  policyRollover?: Maybe<Scalars['Float']['output']>;
  /**
   * This field indicates the service is part of the Flexi service.
   * Waiting period services are returned flattened.
   * Consumers can use this field to group Flexi services again.
   */
  serviceId?: Maybe<Scalars['String']['output']>;
};

export type ServedWaitingPeriodInput = {
  joinDate: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type Service = {
  __typename?: 'Service';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  serviceId: Scalars['ID']['output'];
};

export type ServiceDates = {
  __typename?: 'ServiceDates';
  ambulance?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Scalars['String']['output']>;
  hospital?: Maybe<Scalars['String']['output']>;
};

export type ServiceInput = {
  dob?: InputMaybe<Scalars['String']['input']>;
  productType: ProductType;
};

export type ServiceNamesByWaitingPeriod = {
  __typename?: 'ServiceNamesByWaitingPeriod';
  all?: Maybe<Array<Scalars['String']['output']>>;
  claimable?: Maybe<Array<Scalars['String']['output']>>;
  notClaimable?: Maybe<Array<Scalars['String']['output']>>;
  waitingPeriodEndDate: Scalars['String']['output'];
};

export type SubmitAdhocPaymentInput = {
  amount: Scalars['Float']['input'];
  customerPaymentReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  singleUseToken: Scalars['String']['input'];
};

export type SuspendedDetails = {
  __typename?: 'SuspendedDetails';
  dateFrom?: Maybe<Scalars['String']['output']>;
  dateTo?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type UpdateAgrAddressInput = {
  postal?: InputMaybe<Scalars['String']['input']>;
  residential?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAgrInput = {
  address?: InputMaybe<UpdateAgrAddressInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  incomeTier?: InputMaybe<Scalars['String']['input']>;
  medicare?: InputMaybe<UpdateAgrMedicareInput>;
  others?: InputMaybe<Array<InputMaybe<UpdateAgrOthersInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAgrMedicareInput = {
  expiry?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAgrOthersInput = {
  dependantAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunicationPreferencesInput = {
  primaryContactByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  receiveMarketing?: InputMaybe<ReceiveMarketingInput>;
};

export type UpdateCreditAccountInput = {
  bsb: Scalars['String']['input'];
  channel?: InputMaybe<ChannelType>;
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

export type UpdateIncomeTierInput = {
  incomeTier: Scalars['String']['input'];
};

export type UpdateMemberInput = {
  channel?: InputMaybe<ChannelType>;
  confirmStudentStatus?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['String']['input'];
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
  spousalAuthority?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMembersInput = {
  channel?: InputMaybe<ChannelType>;
  members?: InputMaybe<Array<InputMaybe<MemberEmailPhoneInput>>>;
  mfaToken?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentFrequencyInput = {
  frequency: Scalars['String']['input'];
  nextPaymentDate: Scalars['String']['input'];
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePrimaryMemberInput = {
  address?: InputMaybe<AddressByTypeInput>;
  channel?: InputMaybe<ChannelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
};

export type UploadDocumentsInput = {
  documentType: Scalars['String']['input'];
  files: Array<Scalars['Upload']['input']>;
};

export type UserLoginInput = {
  grant_type: Scalars['String']['input'];
  memberId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
};

export type ValidatedReferralCode = {
  __typename?: 'ValidatedReferralCode';
  isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type VerifyMfaInput = {
  channel?: InputMaybe<ChannelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
};

export type WaitingPeriod = {
  __typename?: 'WaitingPeriod';
  existing?: Maybe<Scalars['String']['output']>;
  standard?: Maybe<Scalars['String']['output']>;
};

export type WaitingPeriodForItem = {
  __typename?: 'WaitingPeriodForItem';
  isExtrasServiceClaimable?: Maybe<Scalars['Boolean']['output']>;
  waitingPeriodEndDate?: Maybe<Scalars['String']['output']>;
};

export type WaitingPeriodForItemInput = {
  memberId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  serviceItemId: Scalars['String']['input'];
};

export type YouthDiscount = {
  __typename?: 'YouthDiscount';
  clientYouthDiscountAge?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  spouseYouthDiscountAge?: Maybe<Scalars['Int']['output']>;
};

export type ClaimHistoryAllResults = {
  __typename?: 'claimHistoryAllResults';
  canFetchMore: Scalars['Boolean']['output'];
  fetchedYear: Scalars['Int']['output'];
  results?: Maybe<Array<Maybe<Claim>>>;
};

export type CreateLeadInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excess?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  hasCashAssistInterest?: InputMaybe<Scalars['Boolean']['input']>;
  income?: InputMaybe<Scalars['Float']['input']>;
  incomeBracket?: InputMaybe<Scalars['String']['input']>;
  incomeTier?: InputMaybe<Scalars['String']['input']>;
  incomeType?: InputMaybe<Scalars['String']['input']>;
  isMember?: InputMaybe<Scalars['Boolean']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  memberCallbackReason?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerAge?: InputMaybe<Scalars['Int']['input']>;
  partnerDob?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  rebateAgeBracket?: InputMaybe<Scalars['String']['input']>;
  rebateAgeTier?: InputMaybe<Scalars['String']['input']>;
  rebatePercentage?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  youthDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type SalesNpsRequestACallFeedbackMutationVariables = Exact<{
  input?: InputMaybe<NpsRequestACallFeedbackInput>;
}>;


export type SalesNpsRequestACallFeedbackMutation = { __typename?: 'Mutation', npsRequestACallFeedback: boolean };

export type FetchProductsWithServicesQueryVariables = Exact<{
  extrasInput?: InputMaybe<ProductWithServiceInput>;
  hospitalInput?: InputMaybe<ProductWithServiceInput>;
}>;


export type FetchProductsWithServicesQuery = { __typename?: 'Query', extras?: Array<string> | null, hospital?: Array<string> | null };

export type FetchRecommendedProductsQueryVariables = Exact<{
  input?: InputMaybe<RecommendProductsInput>;
}>;


export type FetchRecommendedProductsQuery = { __typename?: 'Query', recommendProducts: { __typename?: 'RecommendProducts', extras?: string | null, hospital?: string | null } };

export type GetServicesQueryVariables = Exact<{
  input?: InputMaybe<ServiceInput>;
}>;


export type GetServicesQuery = { __typename?: 'Query', getServices?: Array<{ __typename?: 'Service', description?: string | null, name: string, serviceId: string } | null> | null };

export type GetPasswordPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPasswordPolicyQuery = { __typename?: 'Query', getPasswordPolicy?: { __typename?: 'PasswordConfig', lowerCase: boolean, maxLength: number, minLength?: number | null, numbers: boolean, specialCharacters: boolean, upperCase: boolean, maxEqualConsecutiveCharacters: { __typename?: 'MaxEqualConsecutiveCharacters', enable: boolean, numberCharacters?: number | null } } | null };

export type ValidateReferralCodeQueryVariables = Exact<{
  referralCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValidateReferralCodeQuery = { __typename?: 'Query', validateReferralCode?: { __typename?: 'ValidatedReferralCode', isValid?: boolean | null } | null };

export type CreateLeadMutationMutationVariables = Exact<{
  input?: InputMaybe<CreateLeadInput>;
}>;


export type CreateLeadMutationMutation = { __typename?: 'Mutation', createLead?: { __typename?: 'Lead', id: string } | null };

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', charges?: { __typename?: 'Charges', excess?: { __typename?: 'ChargesExcess', amount?: number | null } | null } | null } | null };


export const SalesNpsRequestACallFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"salesNpsRequestACallFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NpsRequestACallFeedbackInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"npsRequestACallFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SalesNpsRequestACallFeedbackMutation, SalesNpsRequestACallFeedbackMutationVariables>;
export const FetchProductsWithServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchProductsWithServices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extrasInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWithServiceInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hospitalInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWithServiceInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"extras"},"name":{"kind":"Name","value":"productsWithServices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extrasInput"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"hospital"},"name":{"kind":"Name","value":"productsWithServices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hospitalInput"}}}]}]}}]} as unknown as DocumentNode<FetchProductsWithServicesQuery, FetchProductsWithServicesQueryVariables>;
export const FetchRecommendedProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchRecommendedProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RecommendProductsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extras"}},{"kind":"Field","name":{"kind":"Name","value":"hospital"}}]}}]}}]} as unknown as DocumentNode<FetchRecommendedProductsQuery, FetchRecommendedProductsQueryVariables>;
export const GetServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getServices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}}]}}]}}]} as unknown as DocumentNode<GetServicesQuery, GetServicesQueryVariables>;
export const GetPasswordPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPasswordPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPasswordPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lowerCase"}},{"kind":"Field","name":{"kind":"Name","value":"maxLength"}},{"kind":"Field","name":{"kind":"Name","value":"minLength"}},{"kind":"Field","name":{"kind":"Name","value":"numbers"}},{"kind":"Field","name":{"kind":"Name","value":"specialCharacters"}},{"kind":"Field","name":{"kind":"Name","value":"upperCase"}},{"kind":"Field","name":{"kind":"Name","value":"maxEqualConsecutiveCharacters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enable"}},{"kind":"Field","name":{"kind":"Name","value":"numberCharacters"}}]}}]}}]}}]} as unknown as DocumentNode<GetPasswordPolicyQuery, GetPasswordPolicyQueryVariables>;
export const ValidateReferralCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateReferralCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referralCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateReferralCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referralCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referralCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}}]}}]} as unknown as DocumentNode<ValidateReferralCodeQuery, ValidateReferralCodeQueryVariables>;
export const CreateLeadMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLeadMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"createLeadInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateLeadMutationMutation, CreateLeadMutationMutationVariables>;
export const GetProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"excess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProductQuery, GetProductQueryVariables>;